export enum DefaultEmptyData {
  Dash = "-",
  Empty = "",
  None = "XXXX",
}